import React from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Header from '../Layout/Header.js';
import Footer from '../Layout/Footer.js';
import '../../../index.css'
class AboutUs extends  React.Component {
    constructor(props){
      super(props);      
      this.state = {
          header: "",         
      };     
    }
    render() {
    return (
    <div className="outer-wrapper">
      <Header/>
        <div >
          <div className="container" >
            <div className="row">
              <div className="col-md-12">
                <h1 className="main-heading mt-5">About Us</h1>
                <div className="page-content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos fuga voluptatem officiis cum iure a reprehenderit ipsa omnis in, praesentium eos voluptates esse laboriosam laborum libero voluptas veritatis eveniet aperiam.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat architecto quam repellendus minus vitae iusto quo, sint explicabo consequatur tempora pariatur dignissimos facere eum molestiae ipsum sit, aspernatur quae fugiat!
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos perspiciatis, ratione, quisquam laborum praesentium excepturi unde voluptatum est earum blanditiis voluptate consequuntur sunt, ex. Ratione libero nam, adipisci ut! Dolor.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos perspiciatis, ratione, quisquam laborum praesentium excepturi unde voluptatum est earum blanditiis voluptate consequuntur sunt, ex. Ratione libero nam, adipisci ut! Dolor.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos perspiciatis, ratione, quisquam laborum praesentium excepturi unde voluptatum est earum blanditiis voluptate consequuntur sunt, ex. Ratione libero nam, adipisci ut! Dolor.
                    </p>
                    
                </div>
              </div>
            </div>
            </div>
            <Footer/>
          </div>
        </div>
        )
  }
} 
function mapStateToProps(state) {
  return {}
}
export default withLocalize(withRouter(connect(mapStateToProps, {} )(AboutUs)));



// WEBPACK FOOTER //
// ./src/components/Inc/InfoPage/AboutUs.js